import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadRoles: TourDefinicion = {
  codigo: 'seguridad-roles',
  titulo: 'Roles',
  descripcion: 'Agrupaciones de permisos asignables a usuarios.',
  ruta: '/admin/seguridad/roles',
  permisoMenu: Permisos.ROLES_MENU,
  pasos: [
    {
      id: 'seguridad-roles:header',
      selector: '[data-testid="seguridad-roles.header"]',
      titulo: 'Roles',
      descripcion:
        'Los roles agrupan permisos. Un usuario hereda todos los permisos de los roles que tenga asignados.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-roles:boton-crear',
      selector: '[data-testid="seguridad-roles.boton-crear"]',
      titulo: 'Nuevo rol',
      descripcion:
        'Crea un rol con su código, nombre y descripción. Luego podrás asignarle permisos desde la fila.',
      permisoRequerido: Permisos.ROLES_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'seguridad-roles:tabla',
      selector: '[data-testid="seguridad-roles.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Edita el rol, gestiona sus permisos o elimínalo. Las acciones aparecen en la columna de opciones.',
      side: 'top',
      align: 'center',
    },
  ],
};
